<template>
  <div class="admin-icons">
    <a
      @click.prevent="goTo('/dashboard'); handleCloseMenu()"
      style="cursor: pointer"
      data-toggle="tooltip-custom"
      class="nav-items-distance"
      :class="[_.startsWith($route.path, '/dashboard') && 'active-item']"
      data-placement="right"
      data-trigger="hover"
      data-original-title="Դուրս գալ աշխատանքային վահանակից">
      <div class="d-flex align-items-center nav-items-block" :class="menuProps ? 'justify-content-start' : 'justify-content-center'">
        <div class="sidebar-icon">
          <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.11293 0H5.7493C6.56748 0 7.29476 0.727274 7.38567 1.63637V5.27274C7.38567 6.18183 6.65839 6.9091 5.7493 6.9091H2.11293C1.20384 6.9091 0.476562 6.18183 0.476562 5.27274V1.63637C0.476562 0.727274 1.20384 0 2.11293 0ZM1.8402 5.45456H5.93112V1.36364H1.8402V5.45456ZM11.2042 0H14.8406C15.6588 0 16.3861 0.727274 16.477 1.63637V5.27274C16.477 6.18183 15.7497 6.9091 14.8406 6.9091H11.2042C10.2951 6.9091 9.56787 6.18183 9.56787 5.27274V1.63637C9.56787 0.727274 10.2951 0 11.2042 0ZM10.9315 5.45456H15.0224V1.36364H10.9315V5.45456ZM5.7493 9.09089H2.11293C1.20384 9.09089 0.476562 9.81816 0.476562 10.7273V14.3636C0.476562 15.2727 1.20384 16 2.11293 16H5.7493C6.65839 16 7.38567 15.2727 7.38567 14.3636V10.7273C7.29476 9.81816 6.56748 9.09089 5.7493 9.09089ZM5.93112 14.5454H1.8402V10.4545H5.93112V14.5454ZM11.2042 9.09094H14.8406C15.6588 9.09094 16.3861 9.81822 16.477 10.7273V14.3637C16.477 15.2728 15.7497 16 14.8406 16H11.2042C10.2951 16 9.56787 15.2728 9.56787 14.3637V10.7273C9.56787 9.81822 10.2951 9.09094 11.2042 9.09094ZM10.9315 14.5455H15.0224V10.4546H10.9315V14.5455Z" fill="#6E7485"/>
          </svg>
        </div>
        <h6 class="nav-item-content" :class="menuProps ? 'd-block' : 'd-none'">Գլխավոր</h6>
      </div>
    </a>
    <a
      @click.prevent="goTo('/user-management')"
      style="cursor: pointer"
      data-toggle="tooltip-custom"
      class="nav-items-distance"
      :class="[_.startsWith($route.path, '/user-management') && 'active-item']"
      data-placement="right"
      data-trigger="hover"
      data-original-title="Օգտատերեր"
    >
      <div class="d-flex align-items-center nav-items-block" :class="menuProps ? 'justify-content-start' : 'justify-content-center'">
        <div class="sidebar-icon">
          <svg width="18" height="18" viewBox="0 0 18 18">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.00029 0.00290021C11.5845 0.00290021 13.7072 2.12564 13.7072 4.70984C13.7072 7.29405 11.5845 9.41679 9.00029 9.41679C6.41608 9.41679 4.29334 7.29405 4.29334 4.61755C4.29334 2.03335 6.41608 -0.0893928 9.00029 0.00290021ZM12.3228 4.70984C12.3228 2.86398 10.8461 1.3873 9.00029 1.3873C7.24672 1.3873 5.67774 2.86398 5.67774 4.70984C5.67774 6.5557 7.15443 8.03239 9.00029 8.03239C10.8461 8.03239 12.3228 6.5557 12.3228 4.70984ZM6.2314 10.8934H11.8613C14.7224 10.8934 17.0297 13.2931 17.0297 16.1541V18H0.970703V16.1541C0.970703 13.2008 3.37032 10.8934 6.2314 10.8934ZM2.44739 16.5233H15.553H15.7376V16.1541C15.7376 14.0314 13.984 12.3701 11.9536 12.3701H9.83083V14.862H8.35414V12.3701H6.2314C4.10867 12.3701 2.44739 14.1237 2.44739 16.1541V16.5233Z" fill="#6E7485"/>
          </svg>
        </div>
        <h6 class="nav-item-content" :class="menuProps ? 'd-block' : 'd-none'">Օգտատերեր</h6>
      </div>
    </a>
    <a
      @click.prevent="goTo('/organisation-units')"
      style="cursor: pointer"
      data-toggle="tooltip-custom"
      class="nav-items-distance"
      :class="[_.startsWith($route.path, '/organisation-units') && 'active-item']"
      data-placement="right"
      data-trigger="hover"
      data-original-title="Ստորաբաժանումներ"
    >
      <div class="d-flex align-items-center nav-items-block" :class="menuProps ? 'justify-content-start' : 'justify-content-center'">
        <div class="sidebar-icon">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 2.25C1.5 1.83579 1.83579 1.5 2.25 1.5H6.75C7.16421 1.5 7.5 1.83579 7.5 2.25V5.25C7.5 5.66421 7.16421 6 6.75 6H5.25V8.25H12.75V6H11.25C10.8358 6 10.5 5.66421 10.5 5.25V2.25C10.5 1.83579 10.8358 1.5 11.25 1.5H15.75C16.1642 1.5 16.5 1.83579 16.5 2.25V5.25C16.5 5.66421 16.1642 6 15.75 6H14.25V8.25H15.75C16.1642 8.25 16.5 8.58579 16.5 9V15.75C16.5 16.1642 16.1642 16.5 15.75 16.5H2.25C1.83579 16.5 1.5 16.1642 1.5 15.75V9C1.5 8.58579 1.83579 8.25 2.25 8.25H3.75V6H2.25C1.83579 6 1.5 5.66421 1.5 5.25V2.25ZM3 9.75V15H15V9.75H3ZM3 3V4.5H6V3H3ZM12 3V4.5H15V3H12Z" fill="#6E7485"/>
          </svg>
        </div>
        <h6 class="nav-item-content" :class="menuProps ? 'd-block' : 'd-none'">Ստորաբաժանումներ</h6>
      </div>
    </a>
  </div>
</template>

<script>
import isMobile from '@/mixins/isMobileView'

export default {
  name: 'AdminIcons',
  mixins: [isMobile],
  props: {
    menuProps: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleCloseMenu() {
      if (this.isMobile) {
        this.$store.dispatch('settings/toggleInnerMenu')
      }
      this.$emit('close-menu')
    },
    goTo(path) {
      if (this.$route.path !== path) {
        this.$router.push({ path })
      }
      this.handleCloseMenu()
    },
  },
}
</script>

<style scoped>
.nav-item-content {
  position: relative;
}
</style>
